import {Route} from 'react-router-dom';
import {Branch, BranchGroup} from '../navigation';
import NameAndNumbers from './NameAndNumbers';
import TonnageAndType from './TonnageAndType';
import OffshoreInstallation from './OffshoreInstallation';
import React from 'react';
import VesselWidget from './VesselWidget';

const getVesselInForm = (node, isNested) => {
    const urlRoot = `/forms/${node}/vessel`;

    const isNewVessel = {
        field: isNested ? ['vessel_entries', 'new_vessel'] : 'new_vessel',
        comparitor: value => value === 'new' || value === 'edit',
    };

    const isOffshore = {
        field: isNested ? ['vessel_entries', 'vessel_type'] : 'vessel_type',
        comparitor: '===',
        value: 'Offshore Installation',
    };

    return [
        <Route path={`${urlRoot}/select`} key='select'>
            <VesselWidget />
        </Route>,
        <BranchGroup key='new-vessel'>
            <Branch when={isNewVessel}>
                <Route
                    path={`${urlRoot}/name-and-numbers`}
                    key='name-and-numbers'
                >
                    <NameAndNumbers />
                </Route>
                <Route
                    path={`${urlRoot}/tonnage-and-type`}
                    key='tonnage-and-type'
                >
                    <TonnageAndType />
                </Route>
                <BranchGroup key='offshore'>
                    <Branch when={isOffshore}>
                        <Route path={`${urlRoot}/offshore`} key='offshore'>
                            <OffshoreInstallation />
                        </Route>
                    </Branch>
                </BranchGroup>
            </Branch>
        </BranchGroup>,
    ];
};

export default getVesselInForm;
